import helpers from "../../util/helpers.ts";

const raw = [
	"drives",
	"totStartYds",
	"timePos",
	"pts",

	// Keep these in sync with player/stats.ts!
	"fmb",
	"fmbLost",
	"pssCmp",
	"pss",
	"pssYds",
	"pssTD",
	"pssInt",
	"pssLng",
	"pssSk",
	"pssSkYds",
	"rus",
	"rusYds",
	"rusTD",
	"rusLng",
	"tgt",
	"rec",
	"recYds",
	"recTD",
	"recLng",
	"pr",
	"prYds",
	"prTD",
	"prLng",
	"kr",
	"krYds",
	"krTD",
	"krLng",
	"defInt",
	"defIntYds",
	"defIntTD",
	"defIntLng",
	"defPssDef",
	"defFmbFrc",
	"defFmbRec",
	"defFmbYds",
	"defFmbTD",
	"defFmbLng",
	"defSk",
	"defTckSolo",
	"defTckAst",
	"defTckLoss",
	"defSft",
	"fg0",
	"fga0",
	"fg20",
	"fga20",
	"fg30",
	"fga30",
	"fg40",
	"fga40",
	"fg50",
	"fga50",
	"fgLng",
	"xp",
	"xpa",
	"tp",
	"tpa",
	"ko",
	"koYds",
	"koTB",
	"ok",
	"okRec",
	"pnt",
	"pntYds",
	"pntLng",
	"pntTB",
	"pntIn20",
	"pntBlk",
	"pen",
	"penYds",
	"pbw",
	"pba",
	"rbw",
	"rba",
	"skAlw",
] as const;

// raw: recorded directly in game sim
// derived: still stored in database, but not directly recorded in game sim
// not present in this file: transiently derived things, like FG%
const stats = {
	derived: [],
	raw: [
		"gp",
		"min",
		...raw,
		...raw.map((stat) => `opp${helpers.upperCaseFirstLetter(stat)}` as const),
	] as const,
};

export default stats;
